var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs-center"},[(_vm.pages > 1 && _vm.page.page_num <= _vm.pages)?_c('v-pagination',{attrs:{"value":_vm.page.page_num,"length":_vm.pages,"total-visible":_vm.$bp.smallScreen ? 5 : 8},on:{"input":function($event){return _vm.paginationTool($event)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }